import{b as i}from"./ninox-components-DBZCHTU6.js";import n from"styled-components";var d=n.div`
    position: relative;

    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin: var(--drawer-margin, 0);
    gap: inherit;
    border-radius: inherit;

    color: ${({theme:t})=>t.drawer.color};
    pointer-events: auto;
`,m=n.div`
    position: fixed;
    inset: 0;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;

    color: inherit;
    background: none;
    border: none;

    pointer-events: none;
    overflow: hidden;

    transition-timing-function: ease;
    transition-duration: 400ms;
    transition-property: overlay, transform, left, right, top, bottom, visibility;
    transition-behavior: allow-discrete;

    overlay: auto;
    visibility: visible;

    transform: translate(0, 0) scale(1);

    &[aria-expanded='false'] {
        overlay: none;
        visibility: hidden;
        pointer-events: none;

        ${({horizontalAlign:t,verticalAlign:e,transitionHorizontal:a})=>{let r="0",o="0",s=1;return(a||e==="center"||e==="stretch")&&(t==="left"&&(r="-100%"),t==="right"&&(r="100%")),(!a||t==="center"||t==="stretch")&&(e==="top"&&(o="-100%"),e==="bottom"&&(o="100%")),(t==="center"||t==="stretch")&&(e==="center"||e==="stretch")&&(s=0),{transform:`translate(${r}, ${o}) scale(${s})`}}}
    }

    & > ${d} {
        ${({horizontalAlign:t})=>{switch(t){case"left":return{marginLeft:"0",marginRight:"auto"};case"right":return{marginLeft:"auto",marginRight:"0"};case"stretch":return{marginLeft:"0",marginRight:"0",width:"100%"};case"center":default:return{marginLeft:"auto",marginRight:"auto"}}}}

        ${({verticalAlign:t})=>{switch(t){case"top":return{marginTop:"0",marginBottom:"auto"};case"bottom":return{marginTop:"auto",marginBottom:"0"};case"stretch":return{marginTop:"0",marginBottom:"0",height:"100%"};case"center":default:return{marginTop:"auto",marginBottom:"auto"}}}}
    }
`,g=n.aside`
    position: absolute;
    inset: 0;
    z-index: -1;

    background-color: ${({theme:t})=>t.drawer.backgroundColor};
    border-radius: inherit;
    transform: translateZ(0);

    filter: ${({theme:t,level:e})=>e&&`drop-shadow(${i.d0(t.drawer.borderColor)}) drop-shadow(${i[e]()})`};
`;export{d as a,m as b,g as c};
//# sourceMappingURL=ninox-components-2KH2MKET.js.map